<template>
  <div id="wrapper">
    <div id="manage-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- ViewTitleBox -->
      <div class="ibox-tools view-title">
        <h1 class="info-menu view-name">
          <img src="static/img/assets/nav_manage_on_2.png" alt="">
          {{$t('availableUserRegistStr')}}
        </h1>
        <span class="info-right">
        </span>
      </div>
      <!-- /ViewTitleBox -->
      <manage-wrapper-component require-admin>
      <!-- MainView -->
        <b-container class="container mb-0">
          <b-row>
            <b-col cols="5" class="my-1">
              <b-form-group horizontal :label="$t('searchLabelStr')" :label-cols="2" class="mb-0">
                <b-form-input v-model="filter" :placeholder="$t('inputStr')" />
              </b-form-group>
            </b-col>
            <b-col cols="4" class="my-1">
              <b-form-group horizontal :label="$t('selectKeyStr')" :label-cols="6">
                <b-form-select v-model="searchKey" :options="sortOptions" size="lg">
                  <option slot="first" :value="null">-- {{$t('allStr')}} --</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="3" class="my-1">
              <b-form-group horizontal :label="$t('perPageStr')" :label-cols="6">
                <b-form-select :options="pageOptions" v-model="perPage" size="lg" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="my-1">
              <b-btn v-b-modal.modalRegEmails variant="primary" class="mb-4">{{$t('EmailAddressRegistStr')}}</b-btn>
              <b-btn v-on:click="downloadUserEmails" variant="primary" class="mb-4">{{$t('csvDownloadStr')}}</b-btn>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="my-1">
              <label>Showing:</label> {{ totalRows }} ( Total: {{ emailList.length }} )
            </b-col>
            <b-col cols="4" offset="4" class="my-1">
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" align="right"/>
            </b-col>
          </b-row>
        </b-container>
        <!-- <article class="wrapper wrapper-content main-column w-100" style="padding-bottom: 12vh"> -->
        <article class="wrapper wrapper-content main-column w-100">
          <section class="animated fadeInUp">
            <!-- <div>
              <b-btn v-b-modal.modalRegEmails variant="primary" class="mb-4">{{$t('EmailAddressRegistStr')}}</b-btn>
            </div> -->

            <!-- <div class="ibox" style="padding-bottom: 8vh; border-bottom: 3px solid #666;"> -->
            <div class="ibox">
              <b-alert variant="danger" v-for="(errorEmail, index) in errorEmails" :key="index"
                dismissible
                fade
                :show="!errorEmail.dismissed"
                @dismissed="errorEmail.dismissed = true">
                {{ $t(errorEmail.error) + ' : ' + errorEmail.email }}
              </b-alert>
              <!-- <div class="ibox-content">
                <div class="ibox-child" style="padding-bottom: 8vh; border-bottom: 3px solid #999;"> -->
                  <b-table responsive hover caption-top
                    :items="emailList"
                    :fields="tblFields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filterByKeyText"
                    @filtered="onFiltered"
                    :sort-by.sync="tblSortBy"
                    :sort-desc.sync="tblSortDesc"
                    :fixed="true"
                    >
                    <template slot="delete" slot-scope="row">
                      <b-btn v-if="!row.item.uid" size="sm" variant="danger" @click="removeEmail(row)">Ｘ</b-btn>
                      <!-- <b-btn size="sm" variant="danger" :disabled="!!row.item.uid" @click="removeEmail(row)">Ｘ</b-btn> -->
                    </template>
                    <template slot="isDeveloper" slot-scope="row" v-if="isDeveloper">
                      <div @click.stop="onChangeEmailIsDeveloper(row)" :class="{'cursor-div': row.item.uid === ''}">
                        <toggle-button :sync="true" v-if="!row.item.uid"
                          :value="row.value"
                          :color="{unchecked: '#E85050', checked: '#7AE197'}"
                          :disabled="true"
                          :class="{'unclickable': row.item.uid !== ''}"
                          :labels= "isDeveloperToggleStr"
                          :width="75"/>
                      </div>
                    </template>
                    <template slot="isAdmin" slot-scope="row" v-if="isDeveloper || isAdmin">
                      <div @click.stop="onChangeEmailIsAdmin(row)" :class="{'cursor-div': row.item.uid === ''}">
                        <toggle-button :sync="true" v-if="!row.item.uid"
                          :value="row.value"
                          :color="{unchecked: '#E85050', checked: '#7AE197'}"
                          :disabled="true"
                          :class="{'unclickable': row.item.uid !== ''}"
                          :labels= "isAdminToggleStr"
                          :width="75"/>
                      </div>
                    </template>
                    <template slot="isManager" slot-scope="row" v-if="isDeveloper || isAdmin">
                      <div @click.stop="onChangeEmailIsManager(row)" :class="{'cursor-div': row.item.uid === ''}">
                        <toggle-button :sync="true" v-if="!row.item.uid"
                          :value="row.value"
                          :color="{unchecked: '#E85050', checked: '#7AE197'}"
                          :disabled="true"
                          :class="{'unclickable': row.item.uid !== ''}"
                          :labels= "isManagerToggleStr"
                          :width="75"/>
                      </div>
                    </template>
                    <template slot="isForceBrowsing" slot-scope="row" v-if="isDeveloper || isAdmin">
                      <div @click.stop="onChangeEmailIsForceBrowsing(row)" :class="{'cursor-div': row.item.uid === ''}">
                        <toggle-button :sync="true" v-if="!row.item.uid"
                          :value="row.value"
                          :color="{unchecked: '#E85050', checked: '#7AE197'}"
                          :disabled="true"
                          :class="{'unclickable': row.item.uid !== ''}"
                          :labels= "isManagerToggleStr"
                          :width="75"/>
                      </div>
                    </template>
                  </b-table>
                <!-- </div>
              </div> -->
                </div>
          </section>
        </article>
      </manage-wrapper-component>
    </div>
    <!-- Modal Component -->
    <b-modal id="modalRegEmails" v-if="isManager"
            ref="modal"
            :title="$t('EmailAddressRegistStr')"
            centered
            no-close-on-backdrop
            :hide-header=regHandle
            :hide-footer=regHandle
            @ok="handleOk"
            @cancel = "handleClear"
            @shown="clearEmails">
      <div v-if="!regHandle">
        <form @submit.stop.prevent="handleSubmit">
          <b-form-textarea
            v-show="!regEmails.length"
            :placeholder="$t('phtextRegEmails')"
            rows="10"
            max-rows="20"
            v-model="txtEmails"></b-form-textarea>
        </form>
        <b-row class="mt-4">
          <b-col cols="4">
            <button class="btn btn-success block" @click="loadFile">
              {{$t('readFromFileStr')}}
            </button>
          </b-col>
          <b-col>
            <span class="text-danger small">{{$t('EmailRegistAttentionStr')}}</span>
            </br>
            <span class="text-danger small">{{$t('EmailRegistAttentionStr2')}}</span>
            </br>
            <span class="text-danger small">{{$t('EmailRegistAttentionStr3')}}</span>
          </b-col>
        </b-row>
        <!-- <div id="inputParent"> -->
        <form id ='clearfile'><input type="file" accept=".txt, .csv" @change="changeFile" ref="fileInput" class="d-none"></form>
        <!-- <span id ='clearfile'><input type="file" accept=".txt, .csv" @change="changeFile" ref="fileInput" class="d-none"></span> -->
        <!-- </div> -->
      </div>
      <div v-else>
        <b-alert variant="info" show>{{ $t('registerInProgress') }}</b-alert>
        <p>{{ $t('registerEmailsMessage') }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CommonJs from '@/js/common'
// import ManageUserItem from '@/components/Manage/ManageUserItem'
// import ManageUserItemDetail from '@/components/Manage/ManageUserItemDetail'
import { email as emailValidator } from 'vuelidate/lib/validators'
import moment from 'moment'
import encoding from 'encoding-japanese'
import ManageWrapperComponent from '@/components/Manage/ManageWrapperComponent'
// import Vue from 'vue'

export default {
  name: 'ManageEmails',
  mixins: [CommonJs],
  components: {
    // ManageUserItem,
    // ManageUserItemDetail
    ManageWrapperComponent
  },
  data: function () {
    return {
      users: {},
      errorEmails: [],
      regHandle: false,
      // open: false,
      dateFormat: 'YYYY/MM/DD HH:mm:ss',
      txtEmails: '',
      regEmails: [],
      totalRows: 0,
      filter: null,
      searchKey: null,
      sortDesc: false,
      sortBy: null,
      currentPage: 1,
      sortDirection: 'desc',
      pageOptions: [20, 50, 100],
      perPage: 20,
      tblSortBy: 'createdAt',
      tblSortDesc: true,
      detail: ''
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'ManageEmails'
    },
    tblFields () {
      let fields = [
        {
          key: 'delete',
          label: ' ',
          class: 'align-middle',
          sortable: false
        },
        {
          key: 'email',
          label: this.$t('placeholderMailString'),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'organizationPaths',
          label: this.$t('organizationLabelStr'),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'createdAt',
          label: this.$t('registDateStr'),
          class: 'align-middle',
          formatter: this.ymd,
          sortable: true
        }
      ]
      if (this.isDeveloper || this.isAdmin) {
        fields = fields.concat([
          {
            key: 'isAdmin',
            label: this.$t('AdminUserStr'),
            class: 'align-middle',
            sortable: true
          },
          {
            key: 'isManager',
            label: this.$t('managerUserStr'),
            class: 'align-middle',
            sortable: true
          },
          {
            key: 'isForceBrowsing',
            label: this.$t('forceBrowsingUserStr'),
            class: 'align-middle',
            sortable: true
          }
        ])
      }
      if (this.isDeveloper) {
        fields = fields.concat([
          {
            key: 'isDeveloper',
            label: 'Developer',
            class: 'align-middle',
            sortable: true
          }
        ])
      }
      fields.push({
        key: 'uid',
        label: this.$t('userIdStr'),
        class: 'align-middle',
        sortable: true
      })
      return fields
    },
    isManagerToggleStr () {
      return {
        unchecked: this.$t('notManagerUserStr'),
        checked: this.$t('managerUserStr'),
        blank: 'ALL'
      }
    },
    isDeveloperToggleStr () {
      return {
        unchecked: this.$t('notManagerUserStr'),
        checked: 'Developer',
        blank: 'ALL'
      }
    },
    isAdminToggleStr () {
      return {
        unchecked: this.$t('notManagerUserStr'),
        checked: this.$t('AdminUserStr'),
        blank: 'ALL'
      }
    },
    sortOptions () {
      return [
        {
          value: 'email',
          text: this.$t('placeholderMailString')
        },
        {
          value: 'uid',
          text: this.$t('idLabel')
        },
        {
          value: 'organizationPaths',
          text: this.$t('organizationLabelStr')
        }
      ]
    },
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('repository/', [
      'getIsAllowedIPAddressForManagement'
    ]),
    ...mapGetters('_meta/', [
      'getMetaEmailsList',
      'getMetaIsDeveloper',
      'getMetaIsManager',
      'getMetaIsAdmin',
      'getMetaDecodeEmailList',
      'getMetaUsersList'
    ]),
    ...mapGetters('peoples/', [
      'downloadCSV'
    ]),
    ...mapGetters('organizations/', [
      'getOnlyOrganizationsById',
      'getOrganizationNameKeys'
    ]),
    isManager: function () {
      return this.getMetaIsManager
    },
    isAdmin: function () {
      return this.getMetaIsAdmin
    },
    isDeveloper: function () {
      return this.getMetaIsDeveloper
    },
    emailList () {
      const metaEmailList = this.getMetaDecodeEmailList || {}
      console.log('metaemaillist', metaEmailList)
      let emailtbl = []
      const getOrganizationPathName = this.getOrganizationNameKeys
      for (let k of Object.keys(metaEmailList)) {
        // console.log('emailList:metaemaillist', k, metaemaillist[k])
        if (metaEmailList[k].isDeveloper && !this.isDeveloper) {
          console.log('emailList:isDeveloper', k, metaEmailList[k])
          continue
        }
        let organizationNameKeys = ''
        // console.log('metaemaillist:', metaemaillist[k])
        const email = metaEmailList[k].email || k || Object.keys(metaEmailList[k])[0]
        if (metaEmailList[k].hasOwnProperty('organizations')) {
          organizationNameKeys = Object.keys(metaEmailList[k].organizations).filter(x => !this.getOnlyOrganizationsById(x).hasOwnProperty('isInActive')).map(x => getOrganizationPathName[x]).join('<br>')
        }
        emailtbl.push(Object.assign({ uid: '', isDeveloper: false, isAdmin: false, isManager: false, email: email, organizationPaths: organizationNameKeys }, metaEmailList[k]))
      }
      console.log('emailTbl: ', new Date().toISOString(), emailtbl.length, emailtbl)
      return emailtbl
    },
    getUserEmailsCSV () {
      const metaEmailList = this.getMetaDecodeEmailList || {}
      let userEmailsCSV = ''
      const getOrganizationPathName = this.getOrganizationNameKeys
      for (let k of Object.keys(metaEmailList)) {
        const email = metaEmailList[k].email || k || Object.keys(metaEmailList[k])[0]
        let userEmailOrganizations = []
        let emailOrganizations = []
        if (metaEmailList[k] && metaEmailList[k].hasOwnProperty('organizations')) {
          emailOrganizations = Object.keys(metaEmailList[k].organizations).filter(x => !!getOrganizationPathName.hasOwnProperty(x))
        }
        if (emailOrganizations.length > 0) {
          emailOrganizations.forEach(org => userEmailOrganizations.push(email + ',' + getOrganizationPathName[org].replace(/\//g, ',')))
        } else {
          userEmailOrganizations.push(email)
        }
        userEmailsCSV = userEmailsCSV + userEmailOrganizations.join('\r\n') + '\r\n'
      }
      return userEmailsCSV
    }
  },
  mounted: function () {
    this.errorEmails = []
  },
  actions: {
  },
  methods: {
    removeEmail (data) {
      console.log('removeEmail:', data)
      if (!data.item || !data.item.email) { return false }
      this.$swal({
        title: data.item.email + '\n' + this.$t('doDeleteStr'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false
      }).then((result) => {
        console.log('removeRegistableEmails:', data, result)
        if (result.value) {
          const removeRegistableEmails = this.$firebase.functions().httpsCallable('removeUserEmails')
          return removeRegistableEmails({ emails: [ data.item.email.trim() ] })
            .then(res => {
              // this.regResultSet(email, res)
              console.log('removeRegisterableEmails:res', res, data.item.email)
              if (res.status === 'ng') {
                alert(res.error)
              }
            })
            .catch(err => {
              console.log('removeRegisterableEmails:err', err)
            })
        }
      })
    },
    onChangeEmailIsManager: function (row) {
      console.log('onChangeEmailIsManager:', row, this.emailList[row.index], row.item)
      if (row.item.uid !== '') { return }
      this.showRoleSweetAlert(row, 'isManager')
    },
    onChangeEmailIsForceBrowsing: function (row) {
      console.log('onChangeEmailIsForceBrowsing:', row, this.emailList[row.index], row.item)
      if (row.item.uid !== '') { return }
      this.showRoleSweetAlert(row, 'isForceBrowsing')
    },
    onChangeEmailIsDeveloper: function (row) {
      console.log('onChangeEmailIsDeveloper:', row, this.emailList[row.index], row.item)
      if (row.item.uid !== '') { return }
      this.showRoleSweetAlert(row, 'isDeveloper')
    },
    onChangeEmailIsAdmin: function (row) {
      console.log('onChangeEmailIsAdmin:', row, this.emailList[row.index], row.item)
      if (row.item.uid !== '') { return }
      this.showRoleSweetAlert(row, 'isAdmin')
    },
    downloadUserEmails: function () {
      const target = this.getUserEmailsCSV
      console.log('target', target)
      this.downloadCSV(target, 'emaillists')
    },
    showRoleSweetAlert (row, targetIsRole) {
      const setUserEmailRole = this.$firebase.functions().httpsCallable('setUserEmailRole')
      const swalTitle = '更新してよろしいですか？'
      const loadingTitle = '更新中'
      this.$swal({
        title: swalTitle,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success',
        cancelButtonColor: '#f64846',
        cancelButtonClass: 'btn btn-danger',
        animation: false,
        customClass: 'animated fadeInUp',
        width: '35rem',
        position: 'center',
        padding: '2rem'
      }).then((result) => {
        if (result.value) {
          this.$swal({
            title: loadingTitle,
            confirmButtonClass: 'btn btn-success',
            animation: false,
            customClass: 'animated fadeInUp',
            width: '35rem',
            position: 'center',
            padding: '2rem',
            onBeforeOpen: () => {
              this.$swal.showLoading()
              setUserEmailRole({
                targetEmail: row.item.email,
                roles: {
                  [targetIsRole]: !row.item[targetIsRole]
                }
              }).then(() => {
                this.$swal.close()
              })
            }
          })
        }
      })
    },
    regResultsSet (val) {
      if (val.data && (val.data instanceof Array)) {
        for (let v of val.data) {
          console.log('regResultsSet:v', v)
          this.regResultSet(v.email, v)
        }
      } else {
        console.log('regResultsSet:', val)
      }
    },
    regResultSet (email, val) {
      const errors = {
        'Already exists.': 'alreadyMessageStrig',
        'Organization not identified.': 'errOrganizationNotIdentified',
        'Organization not found.': 'errOrganizationNotFound'
      }
      if (Object.keys(errors).includes(val.message)) {
        this.errorEmails.push({
          email,
          error: errors[val.message],
          dismissed: false
        })
      }
      console.log('regResultSet:', email, val)
    },
    regResult (email) {
      email = email || ''
      console.log('regResult: ' + email)
      const setRegistableEmail = this.$firebase.functions().httpsCallable('setRegisterableEmail')
      return setRegistableEmail({email: email.trim()})
        .then(res => {
          this.regResultSet(email, res)
          console.log('setRegisterableEmail:res', res, email)
          // return res
        })
        .catch(err => {
          // this.regResultSet(email, err)
          console.log('setRegisterableEmail:err', err)
          // return false
        })
    },
    regEmailList () {
      console.log('regEmailList: ', this.regEmails)
      // let regemailtbl = []
      if (!this.checkIsEmails()) { return }
      console.log('regEmailList:', this.regEmails)
      const setRegistableEmails = this.$firebase.functions().httpsCallable('setRegisterableUserEmailFromList')
      const sendData = { emails: this.regEmails }
      return setRegistableEmails(sendData)
        .then(res => {
          this.regResultsSet(res)
          console.log('setRegisterableEmails:res', res, this.regEmails)
          this.handleClear()
          // return res
        })
        .catch(err => {
          // this.regResultSet(email, err)
          console.log('setRegisterableEmails:err', err)
          this.handleClear()
          // return false
        })
    },
    checkIsEmails () {
      let notEmails = []
      for (let email of this.regEmails) {
        const trimEmail = email.replace(/\t/g, ',').split(',')[0].trim()
        // console.log('checkIsEmails:for ' + email)
        let str = trimEmail.substring(0, trimEmail.indexOf('@'))
        console.log('str', str)
        // if (!trimEmail || !emailValidator(trimEmail) || str.match(/[\u30a0-\u30ff\u3040-\u309f\u3005-\u3006\u30e0-\u9fcf]/)) {
        if (!trimEmail || !emailValidator(trimEmail) || str.match(/[^0-9A-Za-z._%+-]/)) {
          notEmails.push(this.htmlspecialchars(email))
        }
      }
      if (notEmails.length > 0) {
        this.$swal({
          title: this.$t('notEmailColumn'),
          html: notEmails.join('<br>'),
          type: 'warning'
        })
        this.regEmails = []
        this.handleClear()
        return false
      } else {
        return true
      }
    },
    clearEmails () {
      // let file = this.$refs.fileInput.files
      var area = document.getElementById('clearfile')
      console.log({area})
      if (area) {
        area.reset()
        var temp = area.innerHTML
        console.log(temp)
        area.innerHTML = temp
      }
      this.regEmails = []
      this.txtEmails = ''
    },
    filterByKeyText: function (data) {
      if (!this.filter || this.filter === '') { return true }
      const reg = new RegExp(this.filter.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi')
      const strs = {
        email: data.email || '',
        uid: data.uid || '',
        userName: (data.userInfo && data.userInfo.userName) || '',
        dept: (data.userInfo && data.userInfo.dept) || '',
        organizationPaths: data.organizationPaths || ''
      }
      if (strs.hasOwnProperty(this.searchKey)) {
        return reg.test(strs[this.searchKey])
      } else {
        return Object.keys(strs).some(x => { return reg.test(strs[x]) })
      }
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    handleOk (evt) {
      // Prevent modal from closing
      evt.preventDefault()
      let emails = this.txtEmails.trim().split('\r').join('').split('\n')
      if (emails.length) {
        this.regEmails = emails
      }
      console.log('handleOk: ', this.regEmails)
      if (this.regEmails.length && this.regEmails.join('')) {
        this.handleSubmit()
      } else {
        this.handleClear()
      }
    },
    handleSubmit () {
      // for (let email of this.regEmails) {
      //   console.log('regEmail: ' + email)
      // }
      // this.handleClear()
      this.regHandle = true
      this.regEmailList()
    },
    handleClear () {
      console.log('onclick handleClear')
      this.regHandle = false
      this.clearEmails()
      this.$refs.modal.hide()
    },
    ymd (time) {
      return moment(time).format(this.dateFormat)
    },
    loadFile () {
      console.log('loadFile')
      this.$refs.fileInput.click()
    },
    htmlspecialchars: function (str) {
      return (str + '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#039;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    },
    changeFile (event) {
      console.log(this.$refs.fileInput.files)
      if (this.$refs.fileInput.files[0]) {
        console.log('change file::::')
        let reader = new window.FileReader()
        reader.readAsBinaryString(this.$refs.fileInput.files[0])
        reader.onloadend = event => {
          let result = event.target.result
          let text = encoding.convert(result, 'UNICODE', 'AUTO')
          // console.log('* encoding-japanese', {result, text})
          // text = text.replace(/ +/g, '') // 組織名に空白がありうるので削除はやめる。TODO: erase
          this.txtEmails = text.trim().split('\r').join('').split('\n').filter(x => x.length !== 0).join('\n')
          console.log(reader.readyState)
        }
      } else {
        console.log(this.$refs.fileInput)
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.userItem {
  display: flex;
  .profIcon {
    width: 5em;
    height: 5em;
    display: inline-block;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }
}
.vue-js-switch.disabled {
  opacity: 1.0;
}

.vue-js-switch.unclickable {
  opacity: 0.6;
  pointer-events: none;
}

.cursor-div {
  cursor: pointer;
  cursor: hand;
}

.input-file {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/manage/ManageEmails.vue